import { discoverCompetitors } from './agencyService';
import { resolveMarketKeyword } from '../utils/marketKeywordResolver';

/**
 * Search Google Maps for businesses matching a free-text query.
 * Used for anchor GMB selection.
 */
export async function searchBusinesses(query, targetCount = 8) {
  const trimmed = (query || '').trim();
  if (!trimmed) {
    return [];
  }

  const result = await discoverCompetitors('', '', targetCount, trimmed);
  return result.competitors || [];
}

/**
 * Validate a market keyword by fetching the competitor set Google would return.
 */
export async function validateMarketKeyword(keyword, targetCount = 20) {
  const trimmed = (keyword || '').trim();
  if (!trimmed) {
    return [];
  }

  const result = await discoverCompetitors('', '', targetCount, trimmed);
  return result.competitors || [];
}

/**
 * Run the full keyword resolver pipeline for a selected anchor business.
 */
export async function resolveMarketSearch(anchor, options = {}) {
  return resolveMarketKeyword(anchor, {
    ...options,
    maxValidations: 12,
    validateQuery: (query) => validateMarketKeyword(query, 20),
  });
}
